export const IconDontAdd = () => {
  return (
    <svg
      className="w-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,2.1L12.6,2.1c5.8,0,10.5,4.7,10.5,10.5l0,0c0,5.8-4.7,10.5-10.5,10.5
		l0,0c-5.8,0-10.5-4.7-10.5-10.5l0,0C2.1,6.8,6.8,2.1,12.6,2.1z"
          fill="#E3EAFF"
        />
        <path
          d="M12.6,2.8L12.6,2.8
		c5.4,0,9.9,4.4,9.9,9.9l0,0c0,5.4-4.4,9.9-9.9,9.9l0,0c-5.4,0-9.9-4.4-9.9-9.9l0,0C2.8,7.2,7.2,2.8,12.6,2.8z"
          fill="none"
          stroke="#E3EAFF"
          strokeWidth="1.2904"
        />
        <path
          clipRule="evenodd"
          d="M12.6,6.6c-3.3,0-6,2.7-6,6s2.7,6,6,6c3.3,0,6-2.7,6-6
		S15.9,6.6,12.6,6.6z M5.3,12.6c0-4.1,3.3-7.3,7.3-7.3c4.1,0,7.3,3.3,7.3,7.3s-3.3,7.3-7.3,7.3C8.6,19.9,5.3,16.7,5.3,12.6z"
          fill="#3366FF"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M12.6,7.9c0.4,0,0.7,0.3,0.7,0.7v3.6l2.3,1.1
		c0.3,0.2,0.5,0.6,0.3,0.9c-0.2,0.3-0.6,0.5-0.9,0.3l-2.7-1.3c-0.2-0.1-0.4-0.3-0.4-0.6v-4C12,8.2,12.3,7.9,12.6,7.9z"
          fill="#3366FF"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};
